export function fileSizeToMbLabel(bytes: number): string {
    if(!bytes) return '';
    let size = (bytes / (1024 * 1024)).toFixed(1);
    if (size === '0.0') size = '0.1';
    return `(${size.replace('.', ',')} MB)`;
}

export function stripExtension(fileName: string): string {
    if (!fileName) return '';
    const i = fileName.lastIndexOf('.');
    return i === -1 ? fileName : fileName.slice(0, i);
}